/**
 * Basemap tile providers for the map view.
 *
 * XYZ tile URL templates only — all are free and no-key EXCEPT the "custom"
 * slot which lets a user paste any XYZ template (NearMap, Metromap, Mapbox,
 * Google Maps Static API with their own key, etc.).
 *
 * Google's mt* endpoints are used by many field-tools; if a user has a paid
 * Google Maps subscription they should switch to a keyed URL via the custom
 * slot to stay compliant with Google's terms.
 */
export const BASEMAPS = [
  {
    key: "esri-sat",
    label: "Satellite (Esri)",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    attribution: "Tiles © Esri",
    maxZoom: 22, maxNativeZoom: 19,
    hybridLabels: false,
  },
  {
    key: "esri-streets",
    label: "Streets (Esri)",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
    attribution: "Tiles © Esri",
    maxZoom: 22, maxNativeZoom: 19,
  },
  {
    key: "esri-topo",
    label: "Topo (Esri)",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}",
    attribution: "Tiles © Esri",
    maxZoom: 22, maxNativeZoom: 19,
  },
  {
    key: "google-sat",
    label: "Google Satellite",
    url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
    attribution: "© Google",
    maxZoom: 22, maxNativeZoom: 20,
  },
  {
    key: "google-hybrid",
    label: "Google Hybrid",
    url: "https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
    attribution: "© Google",
    maxZoom: 22, maxNativeZoom: 20,
  },
  {
    key: "google-streets",
    label: "Google Streets",
    url: "https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
    attribution: "© Google",
    maxZoom: 22, maxNativeZoom: 20,
  },
  {
    key: "osm",
    label: "OpenStreetMap",
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: "© OpenStreetMap contributors",
    maxZoom: 19, maxNativeZoom: 19,
  },
];

export const CUSTOM_BASEMAP_KEY = "custom";

export function loadCustomBasemap() {
  try {
    const raw = localStorage.getItem("fp_custom_basemap");
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function saveCustomBasemap(entry) {
  if (!entry) localStorage.removeItem("fp_custom_basemap");
  else localStorage.setItem("fp_custom_basemap", JSON.stringify(entry));
}
